(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-slider-with-icons"] && !Shopify.designMode) return;
  try {
    
let swiperItems = document.querySelectorAll('.swiper-slide');
console.log(swiperItems.length);
  
    var swiper = new Swiper(".mySwiper", {
        loop: true,  
        slidesPerView: 1,

    });
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["meine-neue-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  //jshint esversion:6
console.log('Bootstrap Slider läuft');

const carliItems = document.querySelectorAll('.carousel-inner div');
let currentIndex = 0;

function showFirstLi() {
  carliItems[currentIndex].classList.add('active');
  console.log(carliItems[currentIndex]);
}

function showNextLi() {
  carliItems[currentIndex].classList.remove('active');

  // Überprüfen, ob das letzte Element erreicht ist
  if (carliItems.length - 1 == currentIndex) {
    currentIndex = 0;
  } else {
    currentIndex = currentIndex + 1;
  }

  carliItems[currentIndex].classList.add('active');
  console.log(carliItems[currentIndex]);
}

showFirstLi();
setInterval(showNextLi, 3000);

  } catch(e) { console.error(e); }
})();
})();
